import { noop } from '@hotjar/webapp/lib/function';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { FormSubmittedEventData } from '@hotjar/webapp/tracking/tools/segment';

import * as hotjarTracking from './tools/hotjar';
import type { AccountGroupingData, SiteGroupingData } from './utils';
import { validateEventData } from './validate-event-data';

interface FormSubmitArgs {
  name: string;
  submitSuccess: boolean;
  groupData: AccountGroupingData | SiteGroupingData | undefined;
  data: Segment.SegmentTrackData;
}

/**
 * Track when a form is submitted.
 */
export const formSubmit = ({
  name,
  submitSuccess,
  groupData,
  data,
}: FormSubmitArgs): Promise<void> => {
  const eventName = 'App Form Submitted';
  const isValid = validateEventData(eventName, [name, submitSuccess, groupData]);

  if (!isValid) {
    return Promise.resolve();
  }

  // Make sure we have a Boolean. This is in case we call this from angular which doesn't have typescript.
  const isSubmitSuccess = Boolean(submitSuccess);

  const eventData = FormSubmittedEventData(name, isSubmitSuccess, {
    ...data,
    ...groupData,
  });

  hotjarTracking.tagRecording(`${eventName}: ${name} - ${isSubmitSuccess ? 'Success' : 'Failed'}`);

  // Note: Track should _always_ resolve such that any errors in Track
  // won't affect UX, so handle any rejections.
  return Segment.track(eventName, eventData).then(undefined, noop);
};
